module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Command Log")]), _vm._v(" "), _c('h3', {
    staticClass: "box-tools"
  }, [_c('button', {
    staticClass: "btn btn-sm btn-default",
    attrs: {
      "id": "addAnnotationButton",
      "type": "button",
      "data-toggle": "tooltip",
      "title": "Add Comment"
    },
    on: {
      "click": _vm.refreshTableClick
    }
  }, [_vm._v("\n                    Refresh\n                    "), _c('span', {
    staticClass: "glyphicon glyphicon-refresh"
  })])])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticStyle: {
      "height": "30%",
      "width": "100%"
    },
    attrs: {
      "id": "tableDiv"
    }
  }, [_c('table', {
    staticClass: "table table-hover dataTable",
    attrs: {
      "id": "commandLogTable"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tab-content",
    staticStyle: {
      "padding": "0px"
    }
  }, [_c('div', {
    staticClass: "tab-pane",
    attrs: {
      "id": "complete-jobs-tab"
    }
  })])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-0f134cbc", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0f134cbc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./ClientApp/components/model-command-log/model-command-log.vue.html
// module id = 1075
// module chunks = 0